import PropTypes from 'prop-types';
import React from 'react';
import request from 'superagent';

//TODO:generate search url or possibly just store url params as the search model
class WatchedSearchItem extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      freq: this.props.item.freq,
      name:this.props.item.name,
      validation:{},
      isSaved: false
    };
  }

  onFrequencyChange = (event) => {
    this.setState({freq: event.target.value, isSaved: false});
  }

  onNameChange = (event) => {
    this.setState({name: event.target.value, isSaved: false});
  }

  save = (e) => {
    request
      .post('/api/watches/update')
      .set('Content-Type', 'application/json')
      .send({
        id: this.props.item._id,
        name: this.state.name,
        freq: this.state.freq,
      })
      .end(function (error, response) {
        if(!error){
          this.setState({isSaved: true});
        } else {
          alert('There was an error with your request. Please try again later!');
        }
      }.bind(this));
    e.preventDefault();
  }

  delete = (e) => {
    this.props.delete(e.target.value);
  }

  render() {
    return (
      <tr>
        <td>
          <input type='text'
            onChange={this.onNameChange}
            placeholder="Search Name"
            defaultValue={this.state.name}/>
        </td>
        <td>
          <label className="radio-inline">
            <input type="radio"
              name={'frequency' + this.props.item._id}
              onChange={this.onFrequencyChange}
              value="daily"
              checked={this.state.freq === "daily"}
            /> Daily
          </label>
          <label className="radio-inline">
            <input type="radio"
              name={'frequency' + this.props.item._id}
              onChange={this.onFrequencyChange}
              value="weekly"
              checked={this.state.freq === "weekly"}
            /> Weekly
          </label>
        </td>
        <td>
          <a href={this.props.item.link}>Run search</a>
        </td>
        <td>
          <a href='#' onClick={this.save} className={this.state.isSaved === true ? 'light-button' : ''}>Save</a>
        </td>
        <td>
          <button type="button"
            className="close"
            aria-label="Delete"
            onClick={this.delete}
            value={this.props.item._id}
            title={'Delete ' + this.state.name}
            >×
          </button>
        </td>
      </tr>
    );
  }
}

WatchedSearchItem.propTypes = {
  delete: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired
};

export default WatchedSearchItem;


// WEBPACK FOOTER //
// ./src/components/search/watch-this-search/watched-search-item.jsx